import { Box } from '../../Box';
import { forwardRef } from 'react';
import { badgeStyleBuilder, iconStartBadgeStyleBuilder, iconEndBadgeStyleBuilder, badgeContainerStyleBuilder } from './badgeStyleBuilder';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';

/**
 * Ways to show a status, classification, or count
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Badge = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    children,
    id,
    sx,
    variant,
    startIcon,
    endIcon,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const badgeStyle = mergeSxStyle(badgeStyleBuilder(theme, variant), sx);
  const iconStartStyle = {
    ...iconStartBadgeStyleBuilder(variant, theme)
  };
  const iconEndStyle = {
    ...iconEndBadgeStyleBuilder(variant, theme)
  };
  const _badgeContainerStyle = badgeContainerStyleBuilder(theme);
  return /*#__PURE__*/_jsx(Box, {
    className: className,
    sx: badgeStyle,
    id: id,
    "data-testid": rest['data-testid'] ? `${rest['data-testid']}-badge` : 'badge',
    children: /*#__PURE__*/_jsxs(Box, {
      sx: _badgeContainerStyle,
      children: [startIcon && /*#__PURE__*/_jsx("span", {
        style: iconStartStyle,
        children: startIcon
      }), children, endIcon && /*#__PURE__*/_jsx("span", {
        style: iconEndStyle,
        children: endIcon
      })]
    })
  });
});
Badge.displayName = 'Badge';